export enum TYPE_ELIGIBILITY {
    SEARCH = 'search',
    FUNNEL = 'funnel',
    PTO = 'pto',
    LINEAR = 'linear',
}

export enum TRACKING_TYPE_SEARCH {
    ADDRESS = 'Adresse',
    PHONE = 'Telephone',
    PTO = 'PTO',
}

export enum ELIGIBILITY_STEP_NAME {
    SINGLE_SEARCH_ELIG = 'SINGLE_SEARCH_ELIG',
    LINEAR_ADDRESS_CARTO = 'LINEAR_ADDRESS_CARTO',
    FUNNEL_ELIG = 'FUNNEL_ELIG',
    HOUSING = 'HOUSING',
    HOUSING_CONFIRM = 'HOUSING_CONFIRM',
    NAME = 'NAME',
    UNKNOWN = 'UNKNOWN',
    LOADING_SEARCH = 'LOADING_SEARCH',
    PTO_ELIG = 'PTO_ELIG',
    GMAP = 'GMAP',
}

export enum ELIGIBILITY_STEP_STATES {
    STEP_STATUS = 'STEP_STATUS',
    STEP_CHANGE = 'STEP_CHANGE',
    ERROR = 'ERROR',
    END = 'END',
    TRACKING = 'TRACKING',
}

export enum ELIGIBILITY_ERROR_STATUS {
    TECHNICAL = 'TECHNICAL',
    FUNCTIONAL = 'FUNCTIONAL',
}

export enum ELIGIBILITY_STEP_STATUS {
    LOADING = 'LOADING',
    INVALID = 'INVALID',
    VALID = 'VALID',
    RESET = 'RESET',
    READY = 'READY',
}

export enum ELIGIBILITY_ERROR_CODE {
    ND_CLIENT_EXISTANT = 'ND_CLIENT_EXISTANT',
    CONSTRUCTION_INTERDITE = 'CONSTRUCTION_INTERDITE',
    DONNEE_INCONNUE = 'DONNEE_INCONNUE',
    ERREUR_ELIGIBILITE_COMMERCIALE = 'ERREUR_ELIGIBILITE_COMMERCIALE',
    INVALID_FORMAT = 'INVALID_FORMAT',
    LOCALISATION_INVALIDE = 'LOCALISATION_INVALIDE',
    NDS = 'NDS',
    ND_DOM_TOM = 'ND_DOM_TOM',
    ND_INCONNU = 'ND_INCONNU',
    ND_LISTE_ROUGE = 'ND_LISTE_ROUGE',
    ND_NON_ATTRIBUE = 'ND_NON_ATTRIBUE',
    PANIER_ABANDONNE = 'PANIER_ABANDONNE',
    PANIER_VALIDE = 'PANIER_VALIDE',
    TECHNICAL = 'TECHNICAL',
    INVALID_TOKEN = 'INVALID_TOKEN',
}

export enum TECHNO_TYPE {
    FTTH = 'ftth',
    BOX5G = 'box5g',
    BOX4G = 'box4g',
    XDSL = 'xdsl',
}
